module.exports = __webpack_public_path__ + "static/media/avel-chuklanov-9OWS4lT5iqQ-unsplash.cef89b3f.jpg";